import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

import { UploadComingSoonProductState } from "@tKgpco/Store/Data/UploadComingSoonProduct/UploadComingSoonProductState";

const initialState: UploadComingSoonProductState = {
    products: []
};

export const reducer = {
    "Custom/UploadComingSoonProduct/Updated": (draft: Draft<UploadComingSoonProductState>, action: UploadComingSoonProductState) => {
        draft.products = action.products;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
